// ============================================================================
// Table Columns: SkillGroups
// Key: skillGroups
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	relationCountRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type {
	SkillGroupSkillDto,
	SkillGroupSummary,
	SkillSummary,
	TeamSkillGroupResponse,
	TeamSummary,
	UserDto,
	UserSkillGroupDto,
} from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const skillGroupsListColumnsConfig = {
	columns: [
		'name',
		relationCountRenderer('userCount', 'users'),
		relationCountRenderer('teamCount', 'teams'),
		relationCountRenderer('skillCount', 'skills'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: SkillGroupSummary) => `/skillGroups/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<SkillGroupSummary>
// #endregion

// #region Relation List Columns
// #region Relation: Skills
export const skillGroupsRelationsSkillsAssignedColumnsConfig = {
	columns: ['skillName', 'skillGroupName'],
} as const satisfies EntityTableConfig<SkillGroupSkillDto>
export const skillGroupsRelationsSkillsAvailableColumnsConfig = {
	columns: [
		'name',
		cellRenderer('userCount', 'number'),
		cellRenderer('teamCount', 'number'),
		cellRenderer('templateCount', 'number'),
		cellRenderer('skillGroupCount', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
} as const satisfies EntityTableConfig<SkillSummary>
// #endregion

// #region Relation: Teams
export const skillGroupsRelationsTeamsAssignedColumnsConfig = {
	columns: ['teamName', 'skillGroupName'],
} as const satisfies EntityTableConfig<TeamSkillGroupResponse>
export const skillGroupsRelationsTeamsAvailableColumnsConfig = {
	columns: [
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		'name',
		cellRenderer('isDefaultTeam', 'boolean'),
		'userGroup',
		'responsibleUserGroup',
		cellRenderer('userCount', 'number'),
		cellRenderer('queueCount', 'number'),
		cellRenderer('skillCount', 'number'),
		cellRenderer('customPageCount', 'number'),
		cellRenderer('skillGroupCount', 'number'),
	],
} as const satisfies EntityTableConfig<TeamSummary>
// #endregion

// #region Relation: Users
export const skillGroupsRelationsUsersAssignedColumnsConfig = {
	columns: [
		'skillGroupName',
		'userEmail',
		'userFirstName',
		'userLastName',
		'userLogonName',
		cellRenderer('isActive', 'boolean'),
		'modifiedBy',
	],
} as const satisfies EntityTableConfig<UserSkillGroupDto>
export const skillGroupsRelationsUsersAvailableColumnsConfig = {
	columns: [
		'firstName',
		'lastName',
		'email',
		cellRenderer('isDisabled', 'boolean'),
		'logonName',
		'extension',
		'customProperty1',
		'customProperty2',
		'customProperty3',
		'customProperty4',
		'customProperty5',
	],
} as const satisfies EntityTableConfig<UserDto>
// #endregion
// #endregion

// #region Columns Config Export
export const skillGroupsColumnsConfig = {
	list: skillGroupsListColumnsConfig,
	relations: {
		skills: {
			assigned: skillGroupsRelationsSkillsAssignedColumnsConfig,
			available: skillGroupsRelationsSkillsAvailableColumnsConfig,
		},
		teams: {
			assigned: skillGroupsRelationsTeamsAssignedColumnsConfig,
			available: skillGroupsRelationsTeamsAvailableColumnsConfig,
		},
		users: {
			assigned: skillGroupsRelationsUsersAssignedColumnsConfig,
			available: skillGroupsRelationsUsersAvailableColumnsConfig,
		},
	},
} as const
// #endregion
